module.exports = function (bootstrap) {

    'use strict';

    bootstrap.directive('makeMyPcp', function () {

        return {
            restrict: 'A',
            replace: false,
            scope: {
                providerId: '=',
                displayName: '=',
                isMyPcp: '=',
                isTypePcp: '=',
                pcpIndex: '=?',
                coremetricsId: '@?',
                returnUrl: '=?',
                fromPage: '=?',
                currentMemberPcpInfo: '=?',
            },
            template: '<button data-ng-show ="!isText" data-requires-login class="make-my-pcp-button btn-link" data-ng-click="goToPcpPor()">{{ btnText }}</button>' +
                       '<div data-ng-show ="isText" ><strong>{{pcpInfoText}}</strong></div>',
            controller: ['$scope', '$location', '$window', 'coremetrics', '$state', function ($scope, $location, $window, coremetrics, $state) {

                $scope.pcpText = ($scope.isTypePcp) ? 'primary care physician' : 'physician of record';
                $scope.pcpInfoText = 'My '  +  $scope.pcpText;

                if ($scope.isMyPCP) {
                    $scope.btnText = 'Remove as ' + $scope.pcpText;
                } else {
                    $scope.btnText = 'Make my ' + $scope.pcpText;
                }

                $scope.goToPcpPor = function () {

                    if (!$scope.returnUrl && !$scope.pcpIndex && !$scope.fromPage) {
                        $state.go('providers.por', {
                            displayName: $scope.displayName || '',
                            providerId: $scope.providerId || '',
                            isTypePcp: $scope.isTypePcp || '',
                            referrer: $scope.referrer
                        });
                    } else {
                        $scope.togglePCP();
                    }
                };

                $scope.togglePCP = function () {

                    $scope.pcpIndex = $scope.pcpIndex || 1;

                    var displayName = encodeURIComponent($scope.displayName).replace(/'/g, "%27").replace(/"/g, "%22") || "",
                        providerId = $scope.providerId || "",
                        host = $location.host(),
                        baseUrl = ($scope.returnUrl) ? $scope.returnUrl : '/mbr/\#!/account/por',
                        url = baseUrl + '?PCPNumber=' + providerId + '&PCPNAME=' + displayName + '&PCPIndex=' + $scope.pcpIndex + ($scope.fromPage ? '&fromPage=' + $scope.fromPage : '');

                    if ($scope.isMyPCP) {
                        coremetrics.elementTag($scope.coremetricsId + ':REMOVE AS PCP', $scope.coremetricsId);
                        $scope.btnText = 'Make my ' + $scope.pcpText;
                        $scope.isMyPCP = false;

                    } else {
                        coremetrics.elementTag($scope.coremetricsId + ':ADD AS PCP', $scope.coremetricsId);
                        $scope.btnText = 'Remove as ' + $scope.pcpText;
                        $scope.isMyPCP = true;
                    }

                    $window.location.href = 'http://' + (($scope.returnUrl) ? url : host + url);

                };

                $scope.getTemplate = function () {

                    if ($scope.currentMemberPcpInfo && $scope.currentMemberPcpInfo.pcpNbr) {

                        if ($scope.providerId === $scope.currentMemberPcpInfo.pcpNbr) {
                            $scope.isText = true;
                            return true;
                        }
                        else {

                            return false;
                        }
                    }
                    else {
                        return false;
                    }

                };

                $scope.isText = $scope.getTemplate();


            }]
        };
    });
};